<script>
import FSexyScroll from "../FSexyScroll.vue";
export default {
  translate25Context: 'vfigma',
  components: { FSexyScroll },
  props: {
    pending: Boolean,
    files: Array,
    filesCountLabel: {
      type: String,
      default: "files uploaded",
    },
    removeLabel: {
      type: String,
      default: "Remove all",
    },
    change: Function,
    delete: Function,
    accept: String,
  },
  data: function () {
    return {};
  },
  computed: {},
  methods: {
    click: function ($event) {
      $(this.$el).find("input.inputfile").click();
    },
    onFileChange: function ($event) {
      this.$emit("change", $event.target.files || $event.dataTransfer.files);
    },
  },
};
</script>
    
<template>
  <div class="f-upload" :class="{ pending: pending }">
    <input
      type="file"
      multiple
      name="file"
      id="file"
      class="inputfile"
      @change="onFileChange($event)"
      :accept="accept"
    />
    <f-button :pending="pending" type="primary" @click="click($event)"
      ><slot></slot
    ></f-button>

    <!-- Multiple files  -->
    <div class="f-files" v-if="files && Object.values(files).length">
      <div class="f-header">
        <div class="f-files-count">
          <span>{{ Object.values(files).length }}</span
          ><span>{{ $vt(filesCountLabel) }}</span>
        </div>
        <div class="f-remove">
          <f-button type="link" @click="$emit('delete')">{{
            $vt(removeLabel)
          }}</f-button>
        </div>
      </div>
      <div class="f-center">
        <div class="f-files-container">
          <f-sexy-scroll>
            <div class="f-files-file" :key="i" v-for="(file, i) in files">
              <f-icon class="f-files-file-icon" icon="fa6-file"></f-icon>
              <div class="f-files-file-name">{{ file.name }}</div>
              <!-- <f-button class="f-files-file-remove"
              ><f-icon icon="fa6-xmark"></f-icon>
            </f-button> -->
            </div>
          </f-sexy-scroll>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.f-upload {
  position: relative;
  .inputfile {
    width: 0;
    height: 0;
    opacity: 0;
    overflow: hidden;
    position: absolute;
    z-index: -1;
  }

  .f-button {
    width: 100%;

    .f-icon {
      font-size: 18px;
    }
  }

  .f-files {
    .f-header {
      display: flex;
      align-items: baseline;
      margin-top: 16px;

      .f-files-count {
        flex: 1 1 auto;
        margin-left: 8px;
        font-family: Lato;
        font-style: normal;
        font-weight: 300;
        font-size: 12px;
        line-height: 125%;
        color: #161615;
        display: flex;
        gap: 7px;
      }
    }
    .f-center {
      .f-files-container {
        display: flex;
        flex-direction: column;
        gap: 28px;
        background: #ffffff;
        border: 1px solid #efefee;
        box-sizing: border-box;
        border-radius: 8px;
        margin-top: 8px;
        max-height: 150px;

        .f-sexy-scroll {
          padding-top: 8px;
        }

        .f-files-file {
          display: flex;
          align-items: center;
          height: 40px;
          margin-bottom: 8px;
          margin-left: 8px;
          margin-right: 8px;
          cursor: pointer;
          padding-left: 12px;
          padding-right: 12px;

          &:hover {
            background-color: var(--blue-a10);
          }

          .f-files-file-icon {
            color: #5cbab6;
            margin-right: 12px;
          }

          .f-files-file-name {
            font-family: Lato;
            font-style: normal;
            font-weight: 500;
            font-size: 14px;
            line-height: 17px;
            color: #161615;
            flex: 1 1 auto;
            text-overflow: ellipsis;
            width: 0;
            overflow: hidden;
            white-space: nowrap;
          }

          .f-files-file-remove {
            color: #c4c4c4;
            width: auto;
            width: 16px;
            height: 16px;
            color: white;
            background-color: #c4c4c4;
            padding: 0;
            border-radius: 100%;
            font-size: 10px;
          }
        }
      }
    }
  }
}

.dark-mode {
  .f-upload .f-files {
    .f-header .f-files-count {
      color: var(--white-a75);
    }
    .f-center .f-files-container {
      background-color: var(--dark);
      border: 1px solid var(--white-a25);

      .f-files-file {
        .f-files-file-icon {
          color: var(--primary);
        }

        .f-files-file-name {
          color: var(--white-a75);
        }
      }
    }
  }
}
</style>